
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { GameData } from "../../server/data/BaseModel";


export class RespinStoppedPresentation extends Presentation {

    private gameData: GameData;

    setGamedData(data: GameData): void {
        this.gameData = data;
    }

    preStart(): void {
    }

    checkForActivation(data: GameData) {
        return true;
    }

    createPresentation(enableSkip: Function) {
        this.PresentationState.setInactive();
    }

    done(): void {
        // Logger.log("Stopped");
    }
}